'use client'

import { Button } from '@radix-ui/themes'

/**
 * Footer for the shared Form on the auth pages: the button stays enabled (the shared default disables it until the
 * form is valid, which also blocks a password manager's autofill); it is only disabled while submitting.
 */
const submitButton = (text: string) => (isSubmitting: boolean) => (
    <Button type="submit" size="3" loading={isSubmitting}>
        {text}
    </Button>
)

export default submitButton
